import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XIcon } from "lucide-react";
import { Dialog } from "radix-ui";
import { cn } from "../lib/cn.js";
/** A panel that slides in from the side: the navigation menu on narrow screens. */
export const Sheet = Dialog.Root;
export const SheetTrigger = Dialog.Trigger;
export const SheetClose = Dialog.Close;
export function SheetContent({ className, children, side = "left", closeLabel, ...props }) {
    return (_jsxs(Dialog.Portal, { children: [_jsx(Dialog.Overlay, { className: "fixed inset-0 z-50 bg-black/40 backdrop-blur-[1px]" }), _jsxs(Dialog.Content, { className: cn("fixed inset-y-0 z-50 flex w-80 max-w-[85vw] flex-col gap-4 bg-card p-4 shadow-pop", side === "left" ? "left-0 border-r border-border" : "right-0 border-l border-border", className), ...props, children: [children, _jsxs(Dialog.Close, { className: "absolute top-4 right-4 rounded-sm opacity-70 hover:opacity-100 focus-visible:ring-2 focus-visible:ring-ring", children: [_jsx(XIcon, { className: "size-4" }), _jsx("span", { className: "sr-only", children: closeLabel })] })] })] }));
}
export function SheetTitle({ className, ...props }) {
    return _jsx(Dialog.Title, { className: cn("text-lg font-semibold", className), ...props });
}
export function SheetDescription({ className, ...props }) {
    return _jsx(Dialog.Description, { className: cn("text-sm text-muted-foreground", className), ...props });
}
//# sourceMappingURL=sheet.js.map